var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-about-us"},[_c('We'),_c('Certificates'),_c('div',{staticClass:"tt-about-us__contact-us"},[_c('ContactUsForm',{attrs:{"for-partners":true}})],1),_c('AboutUsFaq')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }